import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  cursor: "pointer",
  userSelect: "none",
  fontWeight: 700,
  whiteSpace: "nowrap",
};

export const content: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
});

export const arrows: SxProps<Theme> = {
  display: "inline-flex",
  flexDirection: "column",
  lineHeight: 0,
};
